import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { CVState } from '@/store/types/CV.state';
import Tool from '@/models/tool';

export const getters: GetterTree<CVState, RootState> = {
    getGraphicDesignTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == 'Graphic design');
    },
    getSoundTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == 'Sound');
    },
    getWebDevelopmentTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == 'Web development');
    },
    getSoftwareDevelopmentTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == 'Software development');
    },
    getARTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == 'AR');
    },
    getVideoTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == 'Video');
    },
    get3DTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == '3D');
    },
    getWebDesignTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == 'Web design');
    },
    getGenerativeArtTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == 'Generative art');
    },
    getMobileDevelopmentTools(state):Tool[]{
        return state.toolkit.filter( (item) => item.type == 'Mobile development');
    }
};